import { Box, styled, Typography } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('xs')]: {
    height: theme.typography.mobileParagraph.lineHeight,
  },
  [theme.breakpoints.up('xl')]: {
    height: theme.typography.paragraph.lineHeight,
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  marginRight: 2,
  [theme.breakpoints.up('xs')]: {
    ...theme.typography.mobileParagraph,
  },
  [theme.breakpoints.up('xl')]: {
    ...theme.typography.paragraph,
  },
}));
